import { Settlement } from "../../models/Entities/Settlements/Settlement";
import { CommonState } from "../common/state/commonState";

export interface SettlementState extends CommonState<Settlement> {
    // updating all
    isUpdatingAll: boolean;
    isUpdatingAllSuccess: boolean|undefined;
    FailUpdatingAll: boolean;

    // loading by protocol
    isLoadingByProtocol: boolean;
    isLoadingByProtocolSuccess: boolean | undefined;
    FailLoadingByProtocol: boolean;
    settlementsByProtocol: Settlement[];
    currentProtocolId: number | undefined;
}

export const SettlementUnloadState: any = {
    // loading all
    isLoadingAll: false,
    isLoadingAllSuccess: undefined,
    FailGettingAll: false,

    // updating all
    isUpdatingAll: false,
    isUpdatingAllSuccess: undefined,
    FailUpdatingAll: false,

    // loading one
    isLoadingOne: false,
    isLoadingOneSuccess: undefined,
    FailGettingOne: false,

    // saving
    isSaving: false,
    isSavingSuccess: undefined,
    FailSaving: false,
    
    // adding
    isAdding: false,
    isAddingSuccess: undefined,
    FailAdding: false,

    // deleting
    isDeletingOne: false,
    isDeletingOneSuccess: undefined,
    FailDeletingOne: false,

    // loading by protocol
    isLoadingByProtocol: false,
    isLoadingByProtocolSuccess: undefined,
    FailLoadingByProtocol: false,
    settlementsByProtocol: [],
    currentProtocolId: undefined,

};